
export const isValidAnswer = ( answer ) => {
    if( typeof answer !== "string" && typeof answer !== "object") 
        return false        
    return true
}
